
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';


// import Select from 'react-select';

const Classwise_Subject = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [dropdowns, setDropdowns] = useState({ premTypes: [], mainComp: [] });

  // Header State
  const [headerData, setHeaderData] = useState({
    holiday_id: '',
    hs_id: '',
    catg_code: '',
    year1: '',
    year2: '',
    weekly_off1: '',
    weekly_off2: '',
  });

  const [savedfromDate, setSavedFromDate] = useState('');
  const [savedendDate, setSavedEndDate] = useState('');
  const [savedYear1, setSavedYear1] = useState('');

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      holiday_name: '',
      from_date: '',
      to_date: '',
      applicable:'',
    }
  ]);

  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));
  };

  const handleChildChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRows = [...childRows];
    updatedRows[index][name] = value;
    setChildRows(updatedRows);
  };


  useEffect(() => {
    const fetchLists = async () => {
      try {
        const [finyeaRes, premtypeRes, maintcompRes] = await Promise.all([
          axios.get(`${BASE_URL}/api/get_curr_fin_year`),
          axios.get(`${BASE_URL}/api/ddl_prem_type`),
          axios.get(`${BASE_URL}/api/ddl_maint_comp_catg?p_catg_id=3`),
        ]);

        setDropdowns({
          premTypes: premtypeRes.data,
          mainComp: maintcompRes.data,
        });

        const year2 = +finyeaRes.data[0].year1 + 1;

        headerData.year1 = finyeaRes.data[0].year1;
        headerData.years = finyeaRes.data[0].year1 + '-' + year2;
        headerData.fromDate = finyeaRes.data[0].st_fin_date;
        headerData.toDate = finyeaRes.data[0].end_fin_date;

        setSavedFromDate(finyeaRes.data[0].st_fin_date);
        setSavedEndDate(finyeaRes.data[0].end_fin_date);
        setSavedYear1(finyeaRes.data[0].year1);

        //        console.log('premtypeRes.data =====> ', premtypeRes.data);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  const addRow = () => {
    const newIndex = childRows.length + 1; // 1-based index
    const newRow = {
      parent_irn: '',
      maintId: '',
      dispOrder: newIndex, // Default to index + 1
      amount: ''
    };
    setChildRows([...childRows, newRow]);
    //setChildRows([...childRows, { parent_irn: '', maintId: '', dispOrder: '', amount: '' }]);
  };

  const removeRow = (index) => {
    const updatedRows = [...childRows];
    updatedRows.splice(index, 1);
    setChildRows(updatedRows);
  };

  const handleNew = () => {
    setIsEditable(true);
    setHeaderData({
      holiday_id: '',
      hs_id: '',
      catg_code: '',
      year1: '',
      year2: '',
      weekly_off1: '',
      weekly_off2: '',

    });
    setChildRows([{
      holiday_name: '',
      from_date: '',
      to_date: '',
      applicable:'',
    }]);
  };

  const handleSave = async () => {

    // if (!headerData.fromDate || !headerData.toDate) {
    //   //speakMessage('From or To Date cannot be left blank.');
    //   alert('From or To Date cannot be left blank !');
    //   return;
    // }
    // else if (headerData.fromDate > headerData.toDate) {
    //   //speakMessage('From cannot be greater than To Date.');
    //   alert('From cannot be greater than To Date !');
    //   return;
    // }
    // else if (!headerData.premiseType || headerData.premiseType === '') {
    //   //speakMessage('Please Select Premise Type');
    //   alert('Please Select Premise Type !');
    //   return;
    // }

    let lv_err_msg = '';

    for (let i = 0; i < childRows.length; i++) {
      if (!childRows[i].maintId || childRows[i].maintId === '') {
        lv_err_msg = 'Please Select Maintenance Component at Row # ' + (i + 1);
        break;
      }
      else if (!childRows[i].dispOrder || childRows[i].maintId === '0') {
        lv_err_msg = 'Please enter Display Order at Row # ' + (i + 1);
        break;


      }
      else if (!childRows[i].amount || childRows[i].amount === '0' || childRows[i].amount < 0) {
        lv_err_msg = 'Please enter Maintenance Amount greater than 0 at Row # ' + (i + 1);
        break;
      }

    }

    if (lv_err_msg) {
      alert(lv_err_msg);
      return;
    }

    let lv_dupl = 0;

    for (let i = 0; i < childRows.length; i++) {
      for (let j = i + 1; j < childRows.length; j++) {
        if (childRows[i].maintId === childRows[j].maintId) {
          lv_dupl = j;
          break;
        }
      }
      if (lv_dupl > 0) {
        break;
      }
    }

    if (lv_dupl > 0) {
      playBeep();
      alert('Duplicate Maintenance Component selected at Row # ' + (lv_dupl + 1));
      return;
    }

    // DB Validation to check if the given From/To dates, Premise Type already exists or not

    const valResp = await axios.get(`${BASE_URL}/api/validate_maint_struct`,
      { params: { p_Year1: savedYear1, p_fromDate: headerData.fromDate, p_toDate: headerData.toDate, p_PremTypeId: headerData.premiseType } });

    if (valResp.data[0].rows_count > 0) {
      playBeep();
      //speakMessage('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type');
      alert('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type !');
      return;
    }

    // console.log('valResp.data ===> ', valResp.data); 
    // console.log('valResp.data[0].rows_count ===> ', valResp.data[0].rows_count); 

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const structdata = {
      header: headerData,
      details: childRows,
    };

    const response = await axios.post(`${BASE_URL}/api/save_maint_struct`, structdata);

    if (response.data.message === '1') {
      //alert('Maintenance Structure saved successfully !');
      speakMessage('Maintenance Structure saved successfully. Do you like to Add more ?');
      if (window.confirm("Maintenance Structure saved successfully. Do you like to Add more ?")) {
        //headerData.premiseType = '';
        //setDropdowns.premTypes('');
        const updatedChildRows = childRows.map(row => ({
          ...row,
          amount: ''
        }));
        setChildRows(updatedChildRows);
      }
      else {
        setIsEditable(false);
        setHeaderData({
          holiday_id: '',
          hs_id: '',
          catg_code: '',
          year1: '',
          year2: '',
          weekly_off1: '',
          weekly_off2: '',
        });
        setChildRows([{
          holiday_name: '',
          from_date: '',
          to_date: '',
          applicable:'',
        }]);
        headerData.fromDate = savedfromDate;
        headerData.toDate = savedendDate;
      }
    }

  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      handleNew();
      setIsEditable(false);
    }
  };

  const playBeep = () => {
    const audioCtx = new (window.AudioContext || window.AudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    oscillator.type = 'square'; // Other types: sine, square, triangle, sawtooth
    oscillator.frequency.setValueAtTime(440, audioCtx.currentTime); // Frequency in Hz (440Hz = A4 note)
    gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime); // Volume

    oscillator.start();
    oscillator.stop(audioCtx.currentTime + 0.2); // Play for 0.2 seconds
  };

  const speakMessage = (message) => {
    const utterance = new SpeechSynthesisUtterance(message);
    utterance.lang = 'en-US'; // or 'en-GB', 'hi-IN', etc.
    utterance.rate = 1;       // Speed: 0.1 (slow) to 10 (fast)
    utterance.pitch = 1;      // Pitch: 0 to 2
    speechSynthesis.speak(utterance);
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">
        {<Row className="mb-3">
          {/* 
           holiday_id: '',
          hs_id: '',
          catg_code: '',
          year1: '',
          year2: '',
          weekly_off1: '',
          weekly_off2: '', */}

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Staff Category
              </InputGroup.Text>
              <select
                className="form-select"
                name="catg_code"
                value={headerData.catg_code}
                disabled={!isEditable}
              // onChange={handleChange}
              >
                <option value="">-- Select Category--</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Year 1 <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <input
                type="number"
                style={{ textAlign: 'right' }}
                className="form-control"
                name="year1"
                value={headerData.year1}
                disabled={!isEditable}
              // onChange={handleChange}
              />&nbsp;
              <input
                type="number"
                style={{ textAlign: 'right' }}
                className="form-control"
                name="year2"
                value={headerData.year2}
                disabled={!isEditable}
              // onChange={handleChange}
              />
            </InputGroup>
          </Col> 
          </Row>}

          <Row className="mb-3">

            <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Weekly Off-1
              </InputGroup.Text>
              <select
                className="form-select"
                name="weekly_off1"
                value={headerData.weekly_off1}
                disabled={!isEditable}
              // onChange={handleChange}
              >
                <option value="">-- Select Weekly Off-1--</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Weekly Off-2
              </InputGroup.Text>
              <select
                className="form-select"
                name="weekly_off2"
                value={headerData.weekly_off2}
                disabled={!isEditable}
              // onChange={handleChange}
              >
                <option value="">-- Select Weekly Off-2--</option>
              </select>
            </InputGroup>
          </Col>


          </Row>



          
        <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "135px" }}
            onClick={handleNew}
            disabled={isEditable}
          >New
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            style={{ width: "135px" }}
            onClick={handleClear}
          > Clear
          </button>

          <button
            type="button"
            className="btn btn-success"
            style={{ width: "135px" }}
            onClick={handleSave}
            disabled={!isEditable}
          > Save
          </button>
        </div>
      </Card>

      {/* Child Table */}
     
      <Card className="p-3">
              <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
                  <thead>
              <tr>
                <th style={{ width: '4%', textAlign: 'center' }}>#</th>
                <th style={{ width: '20%', textAlign: 'left' }}>Holiday Name</th>
                <th style={{ width: '15%', textAlign: 'left' }}>From Date</th>
                <th style={{ width: '15%', textAlign: 'left' }}>To Date</th>
                <th style={{ width: '8%', textAlign: 'left' }}>Applicable</th>
                </tr>
            </thead>

              {/* holiday_name: '',
          from_date: '',
          to_date: '', */}

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    <input style={{ textAlign: 'left' }} disabled
                      type="text" className="form-control" name="holiday_name" value={row.holiday_name} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'left' }} disabled
                      type="date" className="form-control" name="from_date" value={row.from_date} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'left' }} disabled
                      type="date" className="form-control" name="to_date" value={row.to_date} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      disabled={!isEditable}
                      checked={row.applicable === 1}
                      onChange={(e) =>
                        handleChildChange(index, {
                          target: {
                            name: "applicable",
                            value: e.target.checked ? 1 : 0
                          }
                        })
                      }
                    />
                  </td>


                  {/* <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                    )}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <div className="mb-3">
          <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
        </div> */}
      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default Classwise_Subject;
